var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57129 6.66484H5.52129V6.71484V13.572V13.622H5.57129H6.71415H6.76415V13.572V6.71484V6.66484H6.71415H5.57129Z",
    fill: "#4B4B4B",
    stroke: "black",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.66484H8.95V6.71484V13.572V13.622H9H10.1429H10.1929V13.572V6.71484V6.66484H10.1429H9Z",
    fill: "#4B4B4B",
    stroke: "black",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.23516H0.95V3.28516V4.42801V4.47801H1H2.09286V15.8566C2.09286 16.173 2.21853 16.4764 2.44224 16.7001C2.66594 16.9238 2.96935 17.0494 3.28571 17.0494H12.4286C12.7449 17.0494 13.0483 16.9238 13.272 16.7001C13.4958 16.4764 13.6214 16.173 13.6214 15.8566V4.47801H14.7143H14.7643V4.42801V3.28516V3.23516H14.7143H1ZM3.33571 15.8066V4.47801H12.3786V15.8066H3.33571Z",
    fill: "#4B4B4B",
    stroke: "black",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57129 0.95H5.52129V1V2.14286V2.19286H5.57129H10.1427H10.1927V2.14286V1V0.95H10.1427H5.57129Z",
    fill: "#4B4B4B",
    stroke: "black",
    strokeWidth: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.efe4b9ef4ed36882da040a8d5c865bb1.svg";
export { ForwardRef as ReactComponent };